var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-container"},[_c('div',{staticClass:"content"},[_c('keep-alive',[_c(_vm.com,{ref:"com",tag:"component",attrs:{"title":_vm.title,"codeId":_vm.codeId},on:{"next":_vm.next,"pre":_vm.pre}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }